import { useDisciplineStore } from '../../modules/Disciplines/stores/disciplineStore';
import { useExercisePrintStore } from '../../modules/Disciplines/stores/exercisePrintStore';
import { useExerciseStore } from '../../modules/Disciplines/stores/exercisesStore';
import { useLessonContentStore } from '../../modules/Disciplines/stores/lessonContentStore';
import { useLessonStore } from '../../modules/Disciplines/stores/lessonStore';
import { useMaterialStore } from '../../modules/Disciplines/stores/materialStore';
import { useModuleStore } from '../../modules/Disciplines/stores/moduleStore';
import { usePodcastStore } from '../../modules/Disciplines/stores/podcastsStore';
import { useSubjectStore } from '../../modules/Disciplines/stores/subjectStore';
import { favoriteFilterStore } from '../../modules/Favorites/stores/favoriteFilterStore';
import { useMyEventsStore } from '../../modules/MyArea/stores/myEventsStore';
import { useRecentContentStore } from '../../modules/MyArea/stores/recentContentStore';
import { useLessonHighlightStore } from '../../modules/MyArea/stores/useLessonHighlight';
import { searchFilterStore } from '../../modules/Search/stores/searchFilters';

export const resetAll = () => {
  const resetDiscipline = useDisciplineStore.getState().resetDiscipline;
  const resetExercises = useExerciseStore.getState().resetExercises;
  const resetExercisePrint =
    useExercisePrintStore.getState().resetExercisePrint;
  const resetLessonContent =
    useLessonContentStore.getState().resetLessonContent;
  const resetLesson = useLessonStore.getState().resetLesson;
  const resetMaterial = useMaterialStore.getState().resetMaterial;
  const resetModule = useModuleStore.getState().resetModule;
  const resetPodcast = usePodcastStore.getState().resetPodcast;
  const resetSubject = useSubjectStore.getState().resetSubject;
  const resetEvent = useMyEventsStore.getState().resetEvent;
  const resetRecentContent =
    useRecentContentStore.getState().resetRecentContent;
  const resetLessonHighlight =
    useLessonHighlightStore.getState().resetLessonHighlight;
  const resetFavorites = favoriteFilterStore.getState().resetFilter;
  const resetSearch = searchFilterStore.getState().resetFilterSearch;

  resetDiscipline();
  resetExercises();
  resetExercisePrint();
  resetLessonContent();
  resetLesson();
  resetMaterial();
  resetModule();
  resetPodcast();
  resetSubject();
  resetEvent();
  resetRecentContent();
  resetLessonHighlight();
  resetFavorites();
  resetSearch();
};
